import { useEffect, useMemo, useState } from 'react';
import { store } from '../../redux/oldStore';
import { ServerResponse } from '../../utils/Server';

const RemoveTempPage = () => {
  const query = useMemo(() => new URLSearchParams(window.location.search), []);
  // URL_PARAM_PERSON is typically "p" (encrypted guid).
  const personParam = query.get('p') || query.get('P') || '';

  const [message, setMessage] = useState('Processing...');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    store.server
      .postApi<ServerResponse<string>>('../RemoveTemp/Remove', { p: personParam })
      .then((x) => {
        if (x.Success) {
          setMessage(typeof x.Value === 'string' ? x.Value : 'Your partial registration has been deleted.');
          setError(null);
        } else {
          setError(x.Message || 'Unable to remove registration.');
        }
      })
      .catch((err) => {
        console.error(err);
        setError('Unable to remove registration.');
      });
  }, [personParam]);

  return (
    <div className="main-body-page grow text-center" data-testid="remove-temp-page">
      {error ? (
        <div className="alert alert-danger" data-testid="remove-temp-error">
          {error}
        </div>
      ) : (
        <h2 data-testid="remove-temp-success">{message}</h2>
      )}
    </div>
  );
};

export default RemoveTempPage;
